import axios from "axios";
import React, { useEffect, useState } from "react";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import Swal from "sweetalert2";
import { baseUrl } from "./Univ";

function AddResult() {
  const [rows, setRows] = useState([]);
  const [elections, setElections] = useState([]);
  const [constituencies, setConstituencies] = useState([]);

  const [form, setForm] = useState({
    election: "",
    constituency: "",
    total_voters: "",
    total_polled: ""
  });

  // ---------------- FETCH DATA ----------------
  const fetchData = () => {
    axios.get(baseUrl + "results/").then(r => setRows(r.data));
  };

  useEffect(() => {
    fetchData();
    axios.get(baseUrl + "elections/").then(r => setElections(r.data));
    axios.get(baseUrl + "constituencies/").then(r => setConstituencies(r.data));
  }, []);

  // ---------------- SUBMIT ----------------
  const submit = () => {

    if (!form.election || !form.constituency) {
      Swal.fire("Error", "Select Election & Constituency", "error");
      return;
    }

    const payload = {
      election: form.election,
      constituency: form.constituency,

      total_voters:
        form.total_voters === "" ? null : parseInt(form.total_voters),

      total_polled:
        form.total_polled === "" ? null : parseInt(form.total_polled),
    };

    axios.post(baseUrl + "results/", payload)
      .then(() => {
        Swal.fire({
          title: "Saved",
          text: "Result added successfully",
          icon: "success",
          timer: 1500,
          showConfirmButton: false
        });

        setTimeout(() => window.location.reload(), 1000);
      })
      .catch(err => {
        console.log(err.response?.data);
        Swal.fire("Error", "Failed to save", "error");
      });
  };

  // ---------------- DELETE ----------------
  const handleDelete = (id) => {
    Swal.fire({
      title: "Are you sure?",
      text: "This record will be deleted",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      confirmButtonText: "Delete"
    }).then(result => {
      if (result.isConfirmed) {
        axios.delete(baseUrl + "delete-results/" + id + "/")
          .then(() => {
            Swal.fire("Deleted!", "", "success");
            fetchData();
          });
      }
    });
  };

  // ---------------- DATAGRID ----------------
  const columns = [
    { field: "id", headerName: "ID", width: 70 },

    {
      field: "election",
      headerName: "Election",
      width: 150,
      renderCell: (params) =>
        params.value?.name || params.value || "-"
    },

    {
      field: "constituency",
      headerName: "Constituency",
      width: 180,
      renderCell: (params) =>
        params.value?.name || params.value || "-"
    },

    { field: "total_voters", headerName: "Voters", width: 120 },
    { field: "total_polled", headerName: "Polled", width: 120 },

    {
      field: "actions",
      headerName: "Actions",
      width: 120,
      sortable: false,
      renderCell: (params) => (
        <button
          className="btn btn-sm btn-danger"
          onClick={() => handleDelete(params.row.id)}
        >
          Delete
        </button>
      ),
    }
  ];

  // ---------------- UI ----------------
  return (
    <section className="container mt-4">

      {/* ===== FORM CARD ===== */}
      <div className="card">
        <h4 className="card-header">Add Result</h4>

        <div className="card-body">

          <select
            className="form-control mb-3"
            value={form.election}
            onChange={e => setForm({ ...form, election: e.target.value })}
          >
            <option value="">-- Select Election --</option>
            {elections.map(e => (
              <option key={e.id} value={e.id}>
                {e.name}
              </option>
            ))}
          </select>

          <select
            className="form-control mb-3"
            value={form.constituency}
            onChange={e => setForm({ ...form, constituency: e.target.value })}
          >
            <option value="">-- Select Constituency --</option>
            {constituencies.map(c => (
              <option key={c.id} value={c.id}>
                {c.name}
              </option>
            ))}
          </select>

          <input
            type="number"
            className="form-control mb-3"
            placeholder="Total Voters"
            value={form.total_voters}
            onChange={e => setForm({ ...form, total_voters: e.target.value })}
          />

          <input
            type="number"
            className="form-control mb-3"
            placeholder="Total Polled"
            value={form.total_polled}
            onChange={e => setForm({ ...form, total_polled: e.target.value })}
          />

          <button className="btn btn-primary" onClick={submit}>
            Save Result
          </button>

        </div>
      </div>

      {/* ===== DATA GRID ===== */}
      <div style={{ width: '100%' }}>
        <DataGrid
          rows={rows}
          columns={columns}
          autoHeight
          pageSize={25}
          rowsPerPageOptions={[25, 50, 100]}
          components={{ Toolbar: GridToolbar }}
          sx={{
            boxShadow: 4,
            border: 4,
            borderColor: "primary.light",
            "& .MuiDataGrid-cell:hover": {
              color: "primary.main",
            },
          }}
        />
      </div>

    </section>
  );
}

export default AddResult;